var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2353_15258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.691 2L3 6.18455V8.36157H21V6.173L11.691 2ZM19.8 7.16157H4.2V6.9386L11.709 3.32315L19.8 6.95015V7.16157Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 16.7656H4.20001V17.9656H19.8V16.7656Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18.8594H3V20.0594H21V18.8594Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 9.5625H4.5V15.5625H5.7V9.5625Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.5625H18.3V15.5625H19.5V9.5625Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 9.5625H14.7V15.5625H15.9V9.5625Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29998 9.5625H8.09998V15.5625H9.29998V9.5625Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 9.5625H11.4V15.5625H12.6V9.5625Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2353_15258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialicons);
export default __webpack_public_path__ + "static/media/Financialicons.3aa39f5dc29240563c1034587e58a83d.svg";
export { ForwardRef as ReactComponent };